import Vue from 'vue'

import { PAYMENT_ORDER_STATUSES } from '@/models/PaymentOrder'

import ApiRequest from '@/services/ApiRequests/ApiRequest'
import PaymentOrderApi from '@/services/Api/PaymentOrderApi'

const paymentOrderTotalCountApiRequest = new ApiRequest(PaymentOrderApi.fetchTotalCount)

const state = () => ({
  totalCount: 0
})

const getters = {
  paymentOrderTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  loadPaymentOrderTotalCount ({ commit }) {
    return paymentOrderTotalCountApiRequest.execute({ status: PAYMENT_ORDER_STATUSES.CREATED })
      .then(payload => commit('setCounter', payload.count))
      .catch(() => {})
  },
  cancelLoadPaymentOrderTotalCount () {
    paymentOrderTotalCountApiRequest.cancel()
  }
}

const mutations = {
  setCounter (state, totalCount) {
    Vue.set(state, 'totalCount', totalCount)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
